import {useState} from "react";

/**
 * State for a list of rows edited through a modal: which row is open (a new
 * one or an existing one) and the save/remove operations on the list.
 *
 * @template {{key: number}} Row
 * @param {Row[]} rows
 * @param {(rows: Row[]) => void} onChange
 */
export const useRowEditor = (rows, onChange) => {
    // null = closed; {} = adding; {key} = editing that row.
    const [editing, setEditing] = useState(/** @type {{key?: number}|null} */ (null));
    const current = rows.find((row) => row.key === editing?.key) ?? null;

    return {
        isOpen: editing !== null,
        current,
        add: () => setEditing({}),
        edit: (/** @type {number} */ key) => setEditing({key}),
        close: () => setEditing(null),
        remove: (/** @type {number} */ key) => onChange(rows.filter((row) => row.key !== key)),
        save: (/** @type {Omit<Row, "key">} */ values) => {
            if (current) {
                onChange(rows.map((row) => (row.key === current.key ? {...row, ...values} : row)));
            } else {
                onChange([...rows, /** @type {Row} */ ({key: Math.max(0, ...rows.map((r) => r.key)) + 1, ...values})]);
            }
            setEditing(null);
        },
    };
};
